// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"style-module__gradient-bg5__aGKvG","popupHeader":"style-module__popupHeader__gc9Ku","oopReminderContainer":"style-module__oopReminderContainer__qElOM"};